import React from 'react';
import { Slider } from 'rsuite';
import { Label } from '../page-components/Label';

interface Props {
	formik: any;
	fieldLabel: string;
	fieldName: string;
}

export const CornerRadiusComponent = (props: Props): React.ReactElement => {
	const { formik, fieldLabel, fieldName } = props;

	const radius = formik.getFieldProps(fieldName).value;

	return (
		<div className="col-6 input-container mb-5 mt-5">
			<Label fieldLabel={fieldLabel} isStandardClass additionalClass='mb-5'/>
			<div className="row align-items-center">
				<div className="col-8">
					<Slider
						progress
						value={radius}
						max={25}
						onChange={(value): void => formik.setFieldValue(fieldName, value)}
					/>
				</div>
				<div className="col-3 corner-radius text-center text-muted">
					{radius}px
				</div>
			</div>
		</div>
	);
};
